<template>
  <div>
    <ProgramCardModal
      :programArticle="selectedProgramArticle"
      @close="clearSelectedArticle"
      :is-mastermind="true"
      :userLoggedIn="userLoggedIn"
      :workshopRegistrationOpened="workshopRegistrationOpened"
      @registerWorkshop="registerWorkshop"
      @unRegisterWorkshop="unRegisterWorkshop"
      :scrollToSection="scrollToSection"
    />

    <div class="md:flex hidden flex-col mt-[100px] gap-[60px] lg:mx-[160px] md:mx-[40px] mx-[20px] relative">
      <div class="w-full h-[70%] bottom-0 absolute opacity-[0.3] bg-[#2699C6] z-[-1]"
           style="filter: blur(150px);"></div>
      <div class="flex flex-row items-center gap-4">
        <p class="text-black lg:text-[56px] text-[28px] font-extrabold">Exec masterminds </p>
      </div>
      <div class="grid grid-cols-[repeat(auto-fit,_minmax(320px,_1fr))] gap-[20px] relative flex-wrap"
           ref="workshops">
        <MastermindCard
          v-for="(workshop, j, key) in masterminds"
          :key="j"
          class="my-2"
          :programArticle="workshop"
          :highlightColor="'blue'"
          @clicked="selectProgramArticle"
          @registerWorkshop="registerWorkshop"
          @unRegisterWorkshop="unRegisterWorkshop"
          :isWorkshop="true"
          :userLoggedIn="userLoggedIn"
          :registerGroupsCheck="registerGroupsCheck[key]"
          :workshopRegistrationState="workshopRegistrationStateMutable"
          :maxWorkshopRegistrationsPerUser="maxWorkshopRegistrationsPerUser"
          :workshopRegistrationOpened="workshopRegistrationOpened"
          :workshopsGroupedByTime="workshopsGroupedByTime"
        />
      </div>
    </div>
    <div class="mx-[20px] md:hidden flex flex-col mt-[80px] relative">
      <div class="absolute z-[-1] h-full w-full opacity-[0.5] bg-brand-blue" style="filter: blur(150px);"></div>
      <p class="text-center text-brand-gray-900 text-[28px] mb-[34px] font-extrabold justify-self-center"
         style="line-height: normal">EXEC Masterminds</p>
      <div class="mb-[30px] transition-all w-full h-full shadow-lg"
           style="overflow: hidden; border-radius: 15px; outline: white solid; outline-offset: -2px; justify-content: center; align-items: center; display: inline-flex">
        <div @click="selectPage(0)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white"
             style="flex: 1 1 0; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 0 ? 'text-brand-blue' : 'text-gray-600'" class="whitespace-nowrap"
               style="font-size: 24px;font-weight: 600; line-height: 32px; ">
            {{ selected === 0 ? selectedPages[0] : nonSelectedPages[0] }}
          </div>
        </div>
        <div class="w-[1px] h-[36px] relative bg-gray-300 rounded-[1px]"></div>
        <div @click="selectPage(1)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white"
             style="flex: 1 1 0; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 1 ? 'text-brand-blue' : 'text-gray-600'" class="whitespace-nowrap"
               style="font-size: 24px;font-weight: 600; line-height: 32px; ">
            {{ selected === 1 ? selectedPages[1] : nonSelectedPages[1] }}
          </div>
        </div>
        <div class="w-[1px] h-[36px] relative bg-gray-300 rounded-[1px]"></div>
        <div @click="selectPage(2)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white"
             style="flex: 1 1 0; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 2 ? 'text-brand-blue' : 'text-gray-600'" class="whitespace-nowrap"
               style="font-size: 24px; font-weight: 600; line-height: 32px; ">
            {{ selected === 2 ? selectedPages[2] : nonSelectedPages[2] }}
          </div>
        </div>
        <div class="w-[1px] h-[36px] relative bg-gray-300 rounded-[1px]"></div>
        <div @click="selectPage(3)" class="transition-all px-[20px] py-[8px] min-h-[40px] bg-white"
             style="flex: 1 1 0; border-top-right-radius: 15px; border-bottom-right-radius: 15px; justify-content: center; align-items: center; gap: 8px; display: flex">
          <div :class="selected === 3 ? 'text-brand-blue' : 'text-gray-600'" class="whitespace-nowrap"
               style="font-size: 24px; font-weight: 600; line-height: 32px;">
            {{ selected === 3 ? selectedPages[3] : nonSelectedPages[3] }}
          </div>
        </div>
      </div>
      <div class="relative w-full mx-auto">
        <div class="overflow-hidden relative"
             :style="{height: getMaxCapacityInLargestHall*180 + 'px'}">
          <div
            class="absolute inset-0 transition-transform duration-300 ease-in-out"
            :class="{
          'translate-x-0 z-10 opacity-100': index === selected,
          'translate-x-full': index > selected,
          '-translate-x-full': index < selected
        }"
            :key="key"
            v-for="(group, key, index) in workshopsGroupedByHall"
          >
            <MastermindCardMobile
              v-for="(workshop, j) in group"
              :key="j"
              class="my-2"
              :programArticle="workshop"
              :highlightColor="'blue'"
              @clicked="selectProgramArticle"
              @registerWorkshop="registerWorkshop"
              @unRegisterWorkshop="unRegisterWorkshop"
              :isWorkshop="true"
              :userLoggedIn="userLoggedIn"
              :registerGroupsCheck="registerGroupsCheck[key]"
              :workshopRegistrationState="workshopRegistrationStateMutable"
              :maxWorkshopRegistrationsPerUser="maxWorkshopRegistrationsPerUser"
              :workshopRegistrationOpened="workshopRegistrationOpened"
              :workshopsGroupedByTime="workshopsGroupedByTime"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "../Carousel/Carousel.vue";
import ProgramCard from "../Program/ProgramCard.vue";
import ProgramCardModal from "../Program/ProgramCardModal.vue";
import axios from "axios";
import {parse} from 'date-fns';
import MastermindCard from "./MastermindCard.vue";
import MastermindCardMobile from "./MastermindCardMobile.vue";

export default {
  components: {
    MastermindCard,
    MastermindCardMobile,
    Carousel,
    ProgramCard,
    ProgramCardModal,
  },

  props: {
    programEvents: {
      type: Array,
      default: () => [],
    },

    userLoggedIn: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationState: {
      type: Object,
      default: () => {
      },
    },

    maxWorkshopRegistrationsPerUser: {
      type: Number,
    },

    maxRegistrationsPerWorkshop: {
      type: Number,
      default: 28
    },

    workshopRegistrationOpened: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedProgramArticle: null,
      workshopRegistrationStateMutable: this.workshopRegistrationState,
      registerGroupsCheck: {},
      maxItemsInCol: 0,
      selectedPages: ['Masterminds 1', 'Masterminds 2', 'Masterminds 3', 'Masterminds 4'],
      nonSelectedPages: ['1', '2', '3', '4'],
      selected: 0,
      workshopHallMap: {
        ['mastermind1']: 'Masterminds 1',
        ['mastermind2']: 'Masterminds 2',
        ['mastermind3']: 'Masterminds 3',
        ['mastermind4']: 'Masterminds 4',
        ['mastermind5']: 'Masterminds 5',
      },
    };
  },

  watch: {
    workshopRegistrationStateMutable: {
      handler() {
        let times = Object.keys(this.workshopsGroupedByTime);
        times.forEach(startTime => {
          this.registerGroupsCheck[startTime] = this.userHasWorkshopRegisteredForGivenTimeSlot(startTime);
        })
      },
      immediate: true
    }
  },

  computed: {
    getMaxCapacityInLargestHall() {
      const grouped = this.workshopsGroupedByHall

      let maxTotalCapacity = 0;

      for (const hall in grouped) {
        const workshops = grouped[hall];
        if (workshops.length > maxTotalCapacity) {
          maxTotalCapacity = workshops.length;
        }
      }

      return maxTotalCapacity;
    },
    workshopsGroupedByTime() {
      const workshops = this.programEvents.filter(
        (event) => event.type === "mastermind"
      );

      const grouped = workshops.reduce((groupedWorkshops, workshop) => {

        let parsedWorkshopEnd = parse(workshop.end, "HH:mm", new Date());

        if (groupedWorkshops[parsedWorkshopEnd] == null) {
          groupedWorkshops[parsedWorkshopEnd] = []
        }

        let capacity = this.maxRegistrationsPerWorkshop;

        if (this.workshopRegistrationStateMutable.workshop_registrations[workshop.id]) {
          capacity -= this.workshopRegistrationStateMutable.workshop_registrations[workshop.id].count;
        }

        groupedWorkshops[parsedWorkshopEnd].push({...workshop, capacity: capacity});

        return groupedWorkshops;
      }, {});

      return Object.keys(grouped)
        .sort()
        .reduce((a, c) => ((a[c] = grouped[c]), a), {});
    },
    masterminds() {
      return this.programEvents.filter(
        (event) => event.type === "mastermind" && ['mastermind1', 'mastermind2', 'mastermind3', 'mastermind4'].includes(event.hall)
      );
    },
    workshopsGroupedByHall() {
      const workshops = this.programEvents.filter(
        (event) => event.type === "mastermind" && ['mastermind1', 'mastermind2', 'mastermind3', 'mastermind4'].includes(event.hall)
      );

      const grouped = workshops.reduce((groupedWorkshops, workshop) => {

        const parsedWorkshopHall = workshop.hall;

        if (groupedWorkshops[parsedWorkshopHall] == null) {
          groupedWorkshops[parsedWorkshopHall] = []
        }

        let capacity = this.maxRegistrationsPerWorkshop;

        if (this.workshopRegistrationStateMutable.workshop_registrations[workshop.id]) {
          capacity -= this.workshopRegistrationStateMutable.workshop_registrations[workshop.id].count;
        }

        groupedWorkshops[parsedWorkshopHall].push({...workshop, capacity: capacity});

        return groupedWorkshops;
      }, {});

      return Object.keys(grouped)
        .sort()
        .reduce((a, c) => ((a[c] = grouped[c]), a), {});
    }
  },

  methods: {
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
      history.pushState(null, '', window.location.pathname);
    },
    selectPage(idx) {
      if (idx !== this.selected) {
        const prevSelected = this.selected;
        this.selected = idx;

        this.$nextTick(() => {
          const slides = this.$el.querySelectorAll('.transition-transform');
          slides.forEach((slide, index) => {
            if (index === prevSelected) {
              slide.classList.add(idx > prevSelected ? '-translate-x-full' : 'translate-x-full');
            }
          });
        });
      }
    },
    userHasWorkshopRegisteredForGivenTimeSlot(workshopStartTime) {
      for (const workshopForTimeSlot of this.workshopsGroupedByTime[workshopStartTime]) {
        for (const registeredWorkshopId of this.workshopRegistrationStateMutable.user_registrations) {
          if (workshopForTimeSlot.id === registeredWorkshopId) {
            return true;
          }
        }
      }

      return false;
    },

    async registerWorkshop(workshopId) {
      try {
        const res = await axios.post(
          `/api/workshop/${workshopId}/registration`,
          {}
        );
        this.workshopRegistrationStateMutable = res.data;
      } catch (err) {
      }
    },

    async unRegisterWorkshop(workshopId) {
      try {
        const res = await axios.delete(
          `/api/workshop/${workshopId}/registration`,
          {}
        );

        this.workshopRegistrationStateMutable = res.data;
      } catch (err) {
      }
    },

    selectProgramArticleAndAddToURL(article) {
      this.selectedProgramArticle = article;

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('workshopId', article.id)

      const newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    },

    selectProgramArticle(article) {
      this.scrollToSection = false;
      this.selectProgramArticleAndAddToURL(article);
    },

    selectArticleIfPresentInSearchParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const workshopId = urlParams.get('workshopId');

      if (workshopId !== undefined) {
        this.programEvents.forEach((event) => {
          if (event.id === Number(workshopId)) {
            this.scrollToSection = true;
            this.selectProgramArticleAndAddToURL(event);
          }
        });
      }
    }
  },

  mounted() {
    this.selectArticleIfPresentInSearchParams();
  }
};
</script>

<style>
</style>
